<template>
    <div>
        <div class="page-wrap">
            <h2 class="title-page fw-500">
                <i class="fas fa-book mr-2"></i>ซื้อแพคเกจ
            </h2>

            <div class="bank-detail table-content -color-pri">
                <div class="logo-bank d-flex align-items-center">
                    <img src="" alt="" />
                    <div class="bank-detail">
                        <p>SCB</p>
                        <p>ไทยพาณิชย์ จำกัด (มหาชน)</p>
                    </div>
                </div>
                <p>เลขบัญชี</p>
                <div class="d-flex align-items-center my-1">
                    <p class="bank-number">{{ $banknumber(testbank) }}</p>
                    <mdb-badge type="button-copy" class="ml-3" v-clipboard:copy="testbank" v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        color="primary-copy">
                        <small class="text-white">คัดลอกบัญชี</small>
                    </mdb-badge>
                </div>
                <p class="name-bank">บันลือฤทธิ์ พนารักษ์</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                testbank: 1234567890,
                message: "Copy These Text",
            };
        },
        methods: {
            onCopy(e) {
                this.$swal({
                    icon: 'success',
                    html: "คัดลอก " + e.text + " เรียบร้อยแล้ว",
                    timer: 5000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
            },
        },
        mounted() {},
    };
</script>

<style>
.bank-detail p{
    margin: 0 !important;
}
.bank-number{
    font-weight: 600;
    font-size: 1.8rem;
}
.primary-copy{
    background-color:#f5904b !important;
    cursor: pointer;
}
.bank-detail{
    font-weight: 500;
}
</style>